<template>

  <div class="topBk font">
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <div class="container d-flex justify-content-center flex-column align-items-center full-height font" >
      <div class="bg-white p-2 borderRadius d-flex justify-content-center flex-column align-items-center">
      <div class="d-flex flex-column justify-content-center align-items-center">
       <div class="title">小红书扫码登录授权</div>
       <div class="validText">强烈建议使用新注册的小红书账号</div>
       <div class="validText mt-1">如果频繁出现错误，无法登录，请先去小红书官网扫码登录后，再回来重试</div>
      </div>
      
       <div v-if="cookie!=undefined&&cookie.status==1&&qrInfo==''&&!refresh">
            <div class="mt-1">
                目前账户登录状态正常，如需重新登录，请点击下面的“刷新二维码”
            </div>
        </div>
        <div v-else class="mt-1 d-flex justify-content-center flex-column align-items-center">
            <div v-if="!isLoading" style="position: relative;">
                <qrcode-vue :value="qr_url" size=200 />
                <div v-if="timedout" class="middle_abs" style="background:white;padding:0.625rem">超时</div>

                <div v-if="qrInfo!=''" class="middle_abs" style="background:white;padding:0.625rem">{{ qrInfo }}</div>
            </div>
            <div v-else>
              如需重新登录，请刷新二维码
            </div>
           
                
           
            <div class="alertText d-flex align-items-center mt-1">
           用小红书<img src="../assets/xhsIconSmall.png" style="width: 0.225rem;height:0.225rem">扫码登录授权
       </div>
        </div>
      
   
      
   
       <div class="mt-2 d-flex justify-content-between align-items-center">
        <div class="btn normalBtn mr-3" v-if="!isLoading&&qr_url!=undefined" >
           <a :href="qr_url" target="blank">手机登录</a>
   
         </div>
        <div>
          
          
          <div class="btn normalBtn" v-if="!isLoading" @click="refreshQr">
           <span >刷新二维码</span>
   
         </div>
         <div v-else class="btn btnDiabled">
           刷新二维码
         </div>

          
        </div>
        <div @click="back" class="btn ml-1">返回</div>
         
       </div>
      
       <p v-show="error" class="error-message mt-2">{{ error }}</p>
      </div>
   </div>
  </div>
   </template>
   
   <script>
   
   import axios from 'axios';
   
   import QrcodeVue from 'qrcode.vue'
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   
   export default {
     data(){
       return {
         isLoading:false,
         qrReady:false,
         spinnerColor:"#262626",
         error:'',
         normal:false,
         refresh:false,
         timedout:false,
         timeoutTimer:null,
         qrInfo:'',
         accountId:null,
         cookie:null,
         stopCheck:false,
         qr_timeout:undefined,
         axiosSource: axios.CancelToken.source(),
         qr_url:null,
       }
     },
     components: {
       GridLoader,
       QrcodeVue
     },
   
     setup(){
  
        var token=localStorage.getItem('sessionToken')
       
       if(token==undefined || token==null ||token=='')
        {
        this.$router.push('index')
        return
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
       
      
     },
     unmounted(){
      this.stopInterval();
     },
    
   
     beforeUnmount(){
      console.log('cancel axios')
      this.axiosSource.cancel('Operation canceled by the user.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
     },
     mounted(){
      console.log('mouted.........')
  
      this.stopInterval()

       this.accountId = this.$route.params.id;
    
       this.refreshQr()   
     },
  
   
   
     methods:{
      stopInterval(){
        if(this.timeoutTimer!=undefined)
        {
          clearTimeout(this.timeoutTimer)
        }
       
        if(this.qr_timeout!=undefined)
        {
          clearTimeout(this.qr_timeout)
        }
       
        console.log('stop')
        // if(this.qr_timeout!=undefined)
        // {
        //   console.log('stop.....')
        //   clearInterval(this.qr_timeout)
        //   this.qr_timeout=null;
        // }
      },
        checkQr(){
          console.log('set interval timeout')
          this.qr_timeout=setTimeout(()=>this.getQr(), 1000);
          console.log(this.qr_timeout)
        // this.qr_timeout=setInterval(()=>{
        //       this.getQr()
        //   },1000)
      },

  
    back(){
      
     
      this.stopInterval();
        this.$router.go(-1)
      },

      async getQr(){
          try{
            this.error=''
            console.log(this.qr_timeout)
          
            if(this.qr_timeout==undefined)
            {
              console.log('stop checking')
              this.stopInterval()
              return
            }
            var is_pachong=true;

            const response = await axios.get(this.domain+'xhs/get_qr?account_id='+this.accountId+'&is_pachong='+is_pachong,{ 
                  cancelToken: this.axiosSource.token // 在axios请求中使用取消令牌
            });
    
            var data=response.data
            console.log(data)
            if(data.status=='Suc')
            {
              console.log(data)    
                // this.cookie=data.qr  
                var status=data.qr_status  
                        

                if(status==0)
                {
                  console.log('checking.....')
                  this.checkQr()
                  return
                }
                else if(status==1)
                  {
                    // this.axiosSource.cancel('Operation canceled by suc.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                    this.qrInfo='已扫码,请登录'
                    this.checkQr();
                    return
                    // this.save_login()

                  }
               
                 else if(status==2)
                  {
                    this.axiosSource.cancel('Operation canceled by suc.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                    this.qrInfo='稍候'
                    // this.save_login()
                    // this.qrInfo=''
                    this.$router.push('/admin/cks')
                    this.refresh=false;

                  }
                  else if(status==3)
                  {
                    // this.error="出现错误，请刷新二维码重试，如果出现多次，请联系客服。"
                    this.axiosSource.cancel('Operation canceled by error 3.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                      this.timedout=true;
                      this.isLoading=false;
                     
                      this.stopInterval()
                  }
                else if(status==4)
                {
                  this.axiosSource.cancel('Operation canceled by error larger than 2.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                    this.isLoading=false;
                    this.error="出现错误，请刷新二维码重试，如果出现多次，请联系客服。"
                   
                    this.stopInterval()
                }

                else if(status==5)
                {
                  this.axiosSource.cancel('Operation canceled by error larger than 2.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                    this.isLoading=false;
                    this.error="滑块验证失败，请联系客服。"
                   
                    this.stopInterval()
                }
                else if(status==6)
                {
                  
                  this.qrInfo='滑块验证'
                  this.checkQr();
                  return
                  
                }
                
            }
            else
            {
              console.error(data) 
              this.axiosSource.cancel('Operation canceled by error exception.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
                this.isLoading=false;
                this.error="出现错误，请刷新二维码重试，如果出现多次，请联系客服。"
                // this.error=data['msg']
                this.stopInterval()
                
            }
          }
          catch(error)
          {
            console.log(error)
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } else {
                console.error(error)
                this.isLoading=false;
                this.error="出现错误，请刷新二维码重试，如果出现多次，请联系客服。"
                
              }
              this.stopInterval()  
          }
          
        
      },

    

    



      async refreshQr(){
      try{
        this.axiosSource= axios.CancelToken.source()
      
        this.stopInterval()
        this.qrInfo=''
        this.qr_url=''
  
        this.isLoading=true;
        this.timedout=false;

        

       this.refresh=true
       console.log('refresh qr')
       const response = await axios.post(this.signDomain+'get_qrcode',
        {"account_id":this.accountId,"is_pachong":true, cancelToken: this.axiosSource.token});
        // const response = await axios.post(this.signDomain+'xhs/reset_qr',{'id':this.cookie['objectId'],
        // cancelToken: this.axiosSource.token});

        var data=response.data
        
        if(data.status=='Suc')
        {

           this.qr_url=data.qrcode_link
            // var results=data.accounts
            // this.accounts=results;
            // this.cookie=data.qr
            // this.stopCheck=false;
            console.log('start checking')
            // this.checkQr()
     
            // this.timeoutTimer= setTimeout(() => {
            //     this.timedout=true;
            //     this.stopCheck=true;
            //     this.stopInterval();
            // }, 60*1000*2);
            

            this.checkQr()
        }
        else
        {
            console.error(data)
            this.error='出现错误，请尝试刷新二维码，重新生成'
            this.isLoading=false
        }
      }
      catch(error)
      {
        this.error='出现错误，请尝试刷新二维码，重新生成'
          console.error(error)
          this.isLoading=false
      }
      finally{
        this.isLoading=false
      }
   
     
     
    },

     },
   };
   </script>
   <style scoped>
   
   </style>
   